import React, { useState, useEffect } from 'react';
import ErrorGif from '../../images/error2.gif'
import "./Success&ErrorPopups.css"
import { Button, Modal, ModalBody } from 'reactstrap';

function ErrorPopups({ open, message }) {
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);
    useEffect(() => {
        setModal(open)
    }, [open])
    return (
        <div>
            <Modal isOpen={modal} toggle={toggle} className="modal-style">
                <ModalBody className="py-3">
                    <div className="d-flex justify-content-center align-items-center flex-column gap-1">
                        <div className="cards-img mb-5">
                            <img src={ErrorGif} alt="Success Gif" className="img-fit" />
                        </div>
                        <h1 className="title-font-bold fs-1 mb-2 text-uppercase text-base-red ">Error</h1>
                        <p className="text-base-red base-font-700 mb-5">
                            {message}
                        </p>
                        <Button onClick={toggle} className='rounded-pill px-5 py-3 popup-buttons-red'><span className='fs-3 d-flex gap-3 title-font-400 '>Close</span></Button>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
}

export default ErrorPopups;